import { demandConstants } from "./types";

const initialState = { addedFeedback: false, addedAgent: false };

export default (state = initialState, action) => {
  switch (action.type) {
    case demandConstants.ADD_FEEDBACK_REQUEST:
      return {
        ...state,
        addedFeedback: false
      };
    case demandConstants.ADD_FEEDBACK_SUCCESS:
      return {
        ...state,
        addedFeedback: true
      };
    case demandConstants.GET_MY_DEMANDS_REQUEST:
      return {
        ...state,
        ...action.payload
      };
    case demandConstants.GET_MY_DEMANDS_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case demandConstants.ASK_TO_AGENT_REQUEST:
      return {
        ...state,
        addedAgent: false
      };
    case demandConstants.ASK_TO_AGENT_SUCCESS:
      return {
        ...state,
        addedAgent: true
      };
    case demandConstants.CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        addedFeedback: false,
        addedAgent: false
      };
    case demandConstants.DEMANDS_ERROR:
      return {};
    default:
      return state;
  }
};
